import type { GraphNode } from '../graph/nodeDefs.js';
import type { AppState } from './appState.js';
import { BUNDLED_FONT_IDS, resolveBundledFontId, type BundledFontId } from '../sdf/shapeEngine.js';

function collectTextNodeFonts(nodes: readonly GraphNode[], out: Set<BundledFontId>): void {
  for (const node of nodes) {
    if (node.type !== 'Text') continue;
    const rawFont = (node.data as Record<string, unknown>).font;
    if (typeof rawFont !== 'string') continue;
    if (!(BUNDLED_FONT_IDS as readonly string[]).includes(rawFont)) continue;
    out.add(resolveBundledFontId(rawFont));
  }
}

export function collectDocumentFontIds(appState: AppState): BundledFontId[] {
  const fonts = new Set<BundledFontId>();

  collectTextNodeFonts(appState.nodes, fonts);

  for (const layer of Object.values(appState.layerLibrary)) {
    if (layer.geometry.type === 'inline') collectTextNodeFonts(layer.geometry.nodes, fonts);
    if (layer.material.type === 'inline') collectTextNodeFonts(layer.material.nodes, fonts);
  }

  for (const library of [appState.geometryLibrary.builtIn, appState.geometryLibrary.user]) {
    for (const item of Object.values(library)) collectTextNodeFonts(item.nodes, fonts);
  }

  for (const library of [appState.materialLibrary.builtIn, appState.materialLibrary.user]) {
    for (const item of Object.values(library)) collectTextNodeFonts(item.nodes, fonts);
  }

  return [...fonts];
}
